import Vue from 'vue';
import Vuelidate from 'vuelidate';
import VueScrollTo from 'vue-scrollto';

Vue.use(Vuelidate);
Vue.use(VueScrollTo, {
    container: "body",
    duration: 500,
    easing: "ease"
});

require('./components');
require('./init');

Vue.prototype.$bus = new Vue();

new Vue({
    el: '#app',
    components: {
        'contact-form': require('components/ContactForm').default,
        'growl': require('components/Growl').default,
        'gmap': require('components/Map').default,
    }
});